export const getColorClass = (colour) => {
  if (colour === undefined) return 'hover-blue'
  else if(colour === '#019ADE'){return 'hover-blue'}
  else if(colour === '#51CEB6'){return 'hover-teal'}
  else if(colour === '#D8408A'){return 'hover-pink'}
}